/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParagonUninstallRequest
 */
export interface ParagonUninstallRequest {
    /**
     * 
     * @type {string}
     * @memberof ParagonUninstallRequest
     */
    providerType: ParagonUninstallRequestProviderTypeEnum;
}


/**
 * @export
 */
export const ParagonUninstallRequestProviderTypeEnum = {
    Dynamics: 'DYNAMICS',
    Hubspot: 'HUBSPOT',
    Salesforce: 'SALESFORCE',
    Zoho: 'ZOHO'
} as const;
export type ParagonUninstallRequestProviderTypeEnum = typeof ParagonUninstallRequestProviderTypeEnum[keyof typeof ParagonUninstallRequestProviderTypeEnum];


/**
 * Check if a given object implements the ParagonUninstallRequest interface.
 */
export function instanceOfParagonUninstallRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "providerType" in value;

    return isInstance;
}

export function ParagonUninstallRequestFromJSON(json: any): ParagonUninstallRequest {
    return ParagonUninstallRequestFromJSONTyped(json, false);
}

export function ParagonUninstallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParagonUninstallRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerType': json['providerType'],
    };
}

export function ParagonUninstallRequestToJSON(value?: ParagonUninstallRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerType': value.providerType,
    };
}

